import { render, staticRenderFns } from "./SideBarStyle.vue?vue&type=template&id=57b313aa&"
import script from "./SideBarStyle.vue?vue&type=script&lang=js&"
export * from "./SideBarStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports